declare global {
    interface Window {
        pendoVP: any;
    }
}
import { ConfigService } from '$State/ConfigFreezerService';

export class Pendo {
    private static pendingOptions: any = null;
    private static agentLoaded = false;

    public static initializePendo() {
        if (Pendo.agentLoaded) {
            return;
        }

        const apiKey = ConfigService.getPendoApiKey();
        if (!apiKey) {
            console.warn('[Pendo] API key not found, skipping script load');
            return;
        }

        const pendoSrc = `https://content.pendo.kellerencompass.com/agent/static/${apiKey}/pendo.js`;
        if (document.querySelector(`script[src="${pendoSrc}"]`)) {
            return;
        }

        // Save and temporarily remove any existing pendo instance so our pendo.js
        // can bind to window.pendo cleanly (pendo.js uses window.pendo = window.pendo || {})
        const existingPendo = (window as any).pendo;
        if (existingPendo) {
            delete (window as any).pendo;
        }

        const script = document.createElement('script');
        script.async = true;
        script.src = pendoSrc;
        script.onload = () => {
            // pendo.js binds to window.pendo — alias to window.pendoVP
            const realAgent = (window as any).pendo;

            if (realAgent && typeof realAgent.initialize === 'function') {
                window.pendoVP = realAgent;
                Pendo.agentLoaded = true;

                if (Pendo.pendingOptions) {
                    realAgent.initialize(Pendo.pendingOptions);
                    Pendo.pendingOptions = null;
                }
            } else {
                console.warn('[Pendo] real agent not found after load');
            }

            // Always restore any pre-existing pendo instance regardless of outcome
            if (existingPendo) {
                (window as any).pendo = existingPendo;
            }
        };
        script.onerror = () => {
            console.error('[Pendo] Failed to load script');
            // restore any pre-existing pendo instance
            if (existingPendo) {
                (window as any).pendo = existingPendo;
            }
        };

        document.head.appendChild(script);
    }

    public static UpdatePendo(userCreds: any, env: string, integrationplatform: string, fleetid: string, currentUserInfo: any) {
        if (!currentUserInfo) {
            console.warn('[Pendo] currentUserInfo is undefined, skipping');
            return;
        }

        let visitorId: string = '';
        let email: string = '';
        let visitorData: any = {};
        let accountData: any = {};

        if (integrationplatform === 'geotab') {
            const geotabUser = userCreds && userCreds.trim() ? JSON.parse(userCreds) : null;

            if (!geotabUser) {
                console.warn('[Pendo] geotabUser is undefined, skipping');
                return;
            }

            const sessionId = geotabUser.SessionId || '';
            const username = geotabUser.Name || '';
            const database = geotabUser.Database || '';

            visitorId = `${env}_${database}_${username}`;
            email = username;
            visitorData = { usersession: sessionId };
            accountData = { database: database };
        } else if (integrationplatform === 'encompass') {
            visitorId = `${env}_${currentUserInfo.email}`;
            email = currentUserInfo.email;
            visitorData = {};
            accountData = {
                companyId: currentUserInfo.currentFleet?.companyId || '',
                cgRootId: currentUserInfo.currentFleet?.cgRootId || '',
            };
        } else {
            console.warn(`[Pendo] Unknown integration platform: ${integrationplatform}`);
            return;
        }

        const pendoOptions = {
            visitor: {
                id: visitorId,
                integrationplatform: integrationplatform,
                env: env,
                email: email,
                ...visitorData,
            },
            account: {
                id: `${integrationplatform}_${env}_${fleetid}`,
                isVrs: currentUserInfo.currentFleet ? currentUserInfo.currentFleet.isVrs : '',
                isInternal: currentUserInfo.currentFleet ? currentUserInfo.currentFleet.isInternal : '',
                ...accountData,
            },
        };

        if (!Pendo.agentLoaded) {
            Pendo.pendingOptions = pendoOptions;
            return;
        }

        if (window.pendoVP && window.pendoVP.isReady && window.pendoVP.isReady()) {
            window.pendoVP.updateOptions(pendoOptions);
        } else {
            window.pendoVP.initialize(pendoOptions);
        }
    }
}
